<template>
  <div id="page-wrap">
    <PageHeader></PageHeader>
    <main>
      <section class="transactions section-margin">
        <div class="container">
          <div class="row row-spacing-btm">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="page-heading">
                <div class="row">
                  <div class="col-lg-11 col-md-11 col-sm-11 col-xs-12">
                    <h1>Settlements</h1>
                  </div>
                  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-12 text-right">
                    <a href="javascript:void(0)" class="togglesearch">
                      <span class="ic-search"></span>
                      <span class="ic-cross"></span>
                    </a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="data-length-selector">
                      <span>Showing</span>
                      <select class="selectpicker">
                        <option value="">10 results</option>
                        <option value="">30 results</option>
                        <option value="">50 results</option>
                        <option value="">100 results</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="input-group input-daterange">
                      <div class="date-from col-md-5 clearfix">
                        <div class="row">
                          <DatePicker placeholder="dd M, yyyy" v-model="fromDate" :config="config"></DatePicker>
                          <span class="caret"></span>
                        </div>
                      </div>
                      <div class="input-group-addon col-md-2">TO</div>
                      <div class="date-to col-md-5 clearfix">
                        <div class="row">
                          <DatePicker placeholder="dd M, yyyy" v-model="toDate" :config="config"></DatePicker>
                          <span class="caret"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="widget brder-t-r-0">
                <!-- settlements table start -->
                <table id="settlements" class="display table highlight-tr">
                  <thead>
                    <tr>
                      <th>Settlement ID</th>
                      <th>Payment</th>
                      <th>Amount</th>
                      <th>Taxes</th>
                      <th>Fees</th>
                      <th>Refunds</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                    <tr>
                      <td>ABCDE123456789</td>
                      <td class="txt-dark"><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 10,000</td>
                      <td><i class="ic-rupee">`</i> 50</td>
                      <td><i class="ic-rupee">`</i> 100</td>
                      <td>-</td>
                      <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                    </tr>
                  </tbody>
                </table>
                <!-- settlements table end -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import PageHeader from './PageHeader'
  import DatePicker from 'vue-bootstrap-datetimepicker';
  // Import date picker css
  import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
  export default {
    name: 'Settlements',
    data() {
      return {
        fromDate: new Date(),
        toDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        config: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
        }
      }
    },
    components: { PageHeader, DatePicker },
    mounted() {
      
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import '../assets/scss/custom.scss';

</style>



// WEBPACK FOOTER //
// src/components/Settlements.vue